import React,{ Component } from 'react';
import NavBar from './navbar';

export default class MainNavBar  extends NavBar {

    constructor(props){
        super(props,false);
    }

    componentDidMount(){

        let a = $(".navbar").offset().top;

        $(document).scroll(function(){
            if($(this).scrollTop() > a)
                {
                    $('#nav-overlay').addClass('show-overlay');
                } else {
                    $('#nav-overlay').removeClass('show-overlay');
                }
        });
    }

    componentWillUnmount(){
        $(document).unbind('scroll');
    }

}




// WEBPACK FOOTER //
// src/components/layout/main-navbar.js